import { Document } from '../../../../types/models';
import DocumentOperation from './abstract';

export default abstract class SynchronousDocumentOperation extends DocumentOperation {
  // Given a document version, apply the operation to it and
  // return the new version.
  abstract apply(document: Document): Document;
}
